import './PartnersSection.css';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PARTNERS } from '../../../config/partners';

export const PartnersSection: FC = () => {
    const { t } = useTranslation();

    return (
        <section className="partners" aria-labelledby="partners-title">
            <div className="partners__container">
                {/* h2, ne h1 — stranica sme da ima samo jedan h1 (hero u HomePage.tsx) */}
                <h2 id="partners-title" className="partners__title">
                    {t('home.partners.title')}
                </h2>
                <ul className="partners__list">
                    {PARTNERS.map((partner) => (
                        <li key={partner.id} className="partners__item">
                            {partner.url ? (
                                <a
                                    href={partner.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={partner.name}
                                >
                                    <img
                                        src={partner.logo}
                                        alt={partner.name}
                                        className="partners__logo"
                                        loading="lazy"
                                    />
                                </a>
                            ) : (
                                <img
                                    src={partner.logo}
                                    alt={partner.name}
                                    className="partners__logo"
                                    loading="lazy"
                                />
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};
